import React, { useRef, useState } from "react";
import styles from "./style.module.scss";

interface VerificationInputProps {
  length?: number;
  onChange?: (value: string) => void;
  onlyNumbers?: boolean;
  error?: React.ReactNode | string | null;
}

const VerificationInput: React.FC<VerificationInputProps> = ({ length = 4, onChange, onlyNumbers = false, error = null }) => {
  const [values, setValues] = useState<string[]>(Array(length).fill(""));
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (idx: number, val: string) => {
    const regex = onlyNumbers ? /^[0-9]?$/ : /^[a-zA-Z0-9]?$/;
    if (!regex.test(val)) return;
    const newValues = [...values];
    newValues[idx] = val;
    setValues(newValues);
    if (onChange) onChange(newValues.join(""));
    if (val && idx < length - 1) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (idx: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && !values[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        {Array.from({ length }).map((_, idx) => (
          <input
            key={idx}
            ref={el => {
              inputsRef.current[idx] = el;
            }}
            type={onlyNumbers ? "tel" : "text"}
            inputMode={onlyNumbers ? "numeric" : "text"}
            maxLength={1}
            className={`${styles.input} ${error ? styles.input_error : ''}`}
            value={values[idx]}
            onChange={e => handleChange(idx, e.target.value)}
            onKeyDown={e => handleKeyDown(idx, e)}
            autoComplete="one-time-code"
          />
        ))}
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default VerificationInput;
